module.exports = __webpack_public_path__ + "static/media/random.413e406d.png";